import _defineProperty from "/home/ubuntu/rodi/production/es/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/ubuntu/rodi/production/es/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/ubuntu/rodi/production/es/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/ubuntu/rodi/production/es/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/home/ubuntu/rodi/production/es/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/home/ubuntu/rodi/production/es/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/ubuntu/rodi/production/es/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/ubuntu/rodi/production/es/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import "core-js/modules/es.string.trim-end.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { logger, dropUndefinedKeys } from '@sentry/utils';
import { DEFAULT_ENVIRONMENT } from '../constants.js';
import { getCurrentHub } from '../hub.js';
import { Span, SpanRecorder } from './span.js';
/** JSDoc */

var Transaction = /*#__PURE__*/function (_Span) {
  _inherits(Transaction, _Span);

  var _super = _createSuper(Transaction);

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
  function Transaction(transactionContext, hub) {
    var _this;

    _classCallCheck(this, Transaction);

    _this = _super.call(this, transactionContext);

    Transaction.prototype.__init.call(_assertThisInitialized(_this));

    Transaction.prototype.__init2.call(_assertThisInitialized(_this));

    Transaction.prototype.__init3.call(_assertThisInitialized(_this));

    _this._hub = hub || getCurrentHub();
    _this._name = transactionContext.name || '';
    _this.metadata = _objectSpread(_objectSpread({
      source: 'custom'
    }, transactionContext.metadata), {}, {
      spanMetadata: {}
    });
    _this._trimEnd = transactionContext.trimEnd; // this is because transactions are also spans, and spans have a transaction pointer

    _this.transaction = _assertThisInitialized(_this); // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
    // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)

    var incomingDynamicSamplingContext = _this.metadata.dynamicSamplingContext;

    if (incomingDynamicSamplingContext) {
      // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
      _this._frozenDynamicSamplingContext = _objectSpread({}, incomingDynamicSamplingContext);
    }

    return _this;
  }
  /** Getter for `name` property */


  _createClass(Transaction, [{
    key: "__init",
    value:
    /**
     * The reference to the current hub.
     */
    function __init() {
      this._measurements = {};
    }
  }, {
    key: "__init2",
    value: function __init2() {
      this._contexts = {};
    }
  }, {
    key: "__init3",
    value: function __init3() {
      this._frozenDynamicSamplingContext = undefined;
    }
  }, {
    key: "name",
    get: function get() {
      return this._name;
    }
    /** Setter for `name` property, which also sets `source` as custom */
    ,
    set: function set(newName) {
      this.setName(newName);
    }
    /**
     * JSDoc
     */

  }, {
    key: "setName",
    value: function setName(name) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'custom';
      this._name = name;
      this.metadata.source = source;
    }
    /**
     * Attaches SpanRecorder to the span itself
     * @param maxlen maximum number of spans that can be recorded
     */

  }, {
    key: "initSpanRecorder",
    value: function initSpanRecorder() {
      var maxlen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;

      if (!this.spanRecorder) {
        this.spanRecorder = new SpanRecorder(maxlen);
      }

      this.spanRecorder.add(this);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setContext",
    value: function setContext(key, context) {
      if (context === null) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
      } else {
        this._contexts[key] = context;
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setMeasurement",
    value: function setMeasurement(name, value) {
      var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      this._measurements[name] = {
        value: value,
        unit: unit
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setMetadata",
    value: function setMetadata(newMetadata) {
      this.metadata = _objectSpread(_objectSpread({}, this.metadata), newMetadata);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "finish",
    value: function finish(endTimestamp) {
      var _this2 = this;

      // This transaction is already finished, so we should not flush it again.
      if (this.endTimestamp !== undefined) {
        return undefined;
      }

      if (!this.name) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
        this.name = '<unlabeled transaction>';
      } // just sets the end timestamp


      _get(_getPrototypeOf(Transaction.prototype), "finish", this).call(this, endTimestamp);

      var client = this._hub.getClient();

      if (client && client.emit) {
        client.emit('finishTransaction', this);
      }

      if (this.sampled !== true) {
        // At this point if `sampled !== true` we want to discard the transaction.
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

        if (client) {
          client.recordDroppedEvent('sample_rate', 'transaction');
        }

        return undefined;
      }

      var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function (s) {
        return s !== _this2 && s.endTimestamp;
      }) : [];

      if (this._trimEnd && finishedSpans.length > 0) {
        this.endTimestamp = finishedSpans.reduce(function (prev, current) {
          if (prev.endTimestamp && current.endTimestamp) {
            return prev.endTimestamp > current.endTimestamp ? prev : current;
          }

          return prev;
        }).endTimestamp;
      }

      var metadata = this.metadata;

      var transaction = _objectSpread({
        contexts: _objectSpread(_objectSpread({}, this._contexts), {}, {
          // We don't want to override trace context
          trace: this.getTraceContext()
        }),
        spans: finishedSpans,
        start_timestamp: this.startTimestamp,
        tags: this.tags,
        timestamp: this.endTimestamp,
        transaction: this.name,
        type: 'transaction',
        sdkProcessingMetadata: _objectSpread(_objectSpread({}, metadata), {}, {
          dynamicSamplingContext: this.getDynamicSamplingContext()
        })
      }, metadata.source && {
        transaction_info: {
          source: metadata.source
        }
      });

      var hasMeasurements = Object.keys(this._measurements).length > 0;

      if (hasMeasurements) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
        transaction.measurements = this._measurements;
      }

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log("[Tracing] Finishing ".concat(this.op, " transaction: ").concat(this.name, "."));
      return this._hub.captureEvent(transaction);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toContext",
    value: function toContext() {
      var spanContext = _get(_getPrototypeOf(Transaction.prototype), "toContext", this).call(this);

      return dropUndefinedKeys(_objectSpread(_objectSpread({}, spanContext), {}, {
        name: this.name,
        trimEnd: this._trimEnd
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "updateWithContext",
    value: function updateWithContext(transactionContext) {
      _get(_getPrototypeOf(Transaction.prototype), "updateWithContext", this).call(this, transactionContext);

      this.name = transactionContext.name || '';
      this._trimEnd = transactionContext.trimEnd;
      return this;
    }
    /**
     * @inheritdoc
     *
     * @experimental
     */

  }, {
    key: "getDynamicSamplingContext",
    value: function getDynamicSamplingContext() {
      if (this._frozenDynamicSamplingContext) {
        return this._frozenDynamicSamplingContext;
      }

      var hub = this._hub || getCurrentHub();
      var client = hub && hub.getClient();
      if (!client) return {};

      var _ref = client.getOptions() || {},
          environment = _ref.environment,
          release = _ref.release;

      var _ref2 = client.getDsn() || {},
          public_key = _ref2.publicKey;

      var maybeSampleRate = this.metadata.sampleRate;
      var sample_rate = maybeSampleRate !== undefined ? maybeSampleRate.toString() : undefined;

      var _ref3 = hub.getScope().getUser() || {},
          user_segment = _ref3.segment;

      var source = this.metadata.source; // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII

      var transaction = source && source !== 'url' ? this.name : undefined;
      var dsc = dropUndefinedKeys({
        environment: environment || DEFAULT_ENVIRONMENT,
        release: release,
        transaction: transaction,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: this.traceId,
        sample_rate: sample_rate
      }); // Uncomment if we want to make DSC immutable
      // this._frozenDynamicSamplingContext = dsc;

      client.emit && client.emit('createDsc', dsc);
      return dsc;
    }
    /**
     * Override the current hub with a new one.
     * Used if you want another hub to finish the transaction.
     *
     * @internal
     */

  }, {
    key: "setHub",
    value: function setHub(hub) {
      this._hub = hub;
    }
  }]);

  return Transaction;
}(Span);

export { Transaction };